import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Popup.css';

const CreatorPopup = ({ onClose }) => {
  const { i18n } = useTranslation();
  const isSlovak = i18n.language === 'sk';
  const [showAboutMe, setShowAboutMe] = useState(false);

  // Prevent background scrolling when popup is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const toggleAboutMe = () => {
    setShowAboutMe(!showAboutMe);
  };

  return (
    <div className="popup-overlay" onClick={(e) => {
      // Close only if clicking on the overlay background, not the popup content
      if (e.target === e.currentTarget) onClose();
    }}>
      <div className="popup-container creator-popup">
        {/* Decorative elements */}
        <div className="creator-decoration creator-left-ellipse"></div>
        <div className="creator-decoration creator-right-ellipse"></div>
        <div className="creator-decoration creator-dots-1"></div>
        <div className="creator-decoration creator-dots-2"></div>
        
        <div className="popup-header">
          <button className="popup-close" onClick={onClose} aria-label="Zavrieť">×</button>
        </div>
        <div className="popup-content">
          <div className="creator-content">
            <h1 className="creator-title">Vytvorte si profesionálnu webovú aplikáciu na mieru</h1>
            
            <div className="creator-layout">
              {/* Left column - Text content */}
              <div className="creator-text-column">
                <div className="creator-message">
                  <p className="creator-intro">
                    Drahí jogíni a športovci,<br/>
                    Mojím cieľom je po technickej stránke pomôcť šíriť vašu zdraviu a duši prospešnú prax pre čoraz širšie publikum. Uvedomujem si, ako tvrdo sú v dnešnej dobe nastavené ekonomické tlaky a že je skutočné umenie si z jogy spoľahlivo privyrábať, ba sa ňou až živiť. Preto chcem pomôcť, aby si vás ľudia všimli, dostať vás do povedomia a rozšíriť vašu klientelu – za cenu, ktorá je pre VÁS komfortná, najmä v porovnaní s komerčnými poskytovateľmi.
                  </p>
                  <p className="creator-intro">
                    Či už ide o jednoduchú webstránku na sebaprezentáciu, alebo komplexnú webaplikáciu, akou je práve táto stránka, kľudne ma kontaktujte a povedzte, ako si to predstavujete.
                  </p>
                  <p className="creator-intro">
                    Dúfam, že spoločne prinesieme šport, jogu, wellbeing a úžitok všetkým, ktorí to potrebujú. Bolo by krásne trocha povzniesť našu spoločnosť tým, že prispejeme k zvýšeniu počtu zdravých a duchaplných ľudí na Slovensku a inde.
                  </p>
                  
                  <div className="about-me-section">
                    <button 
                      className="about-me-toggle" 
                      onClick={toggleAboutMe}
                      aria-expanded={showAboutMe}
                    >
                      O mne {showAboutMe ? '▲' : '▼'}
                    </button>
                    
                    {showAboutMe && (
                      <div className="about-me-content">
                        <p>
                          Počas a po štúdiu neuropsychológie som mal neustálu zvedavosť a chuť pochopiť ľudskú psychiku a taktiež priviesť tú svoju do čo možno najharmonickejšieho stavu. Cesta ma zaviedla do Číny, kde som počas 11 rokov mal možnosť čo-si sa priučiť od taoistických mníchov, spraviť si z váženého budhistického predstaveného blízkeho priateľa, naučiť sa po čínsky a pochopiť niečo z čínskej kultúry a filozofie. Meditačným a dychovým cvičeniam sa venujem už dlho, no jogu (ásany) som objavil len pred 5 rokmi. Teším sa, že fungujú skvele – Patanjali mal asi pravdu.
                        </p>
                        <p>
                          Po neúspešnej emigrácii do Japonska som sa (v záujme zachovania slobody a finančných prostriedkov) rozhodol reinkarnovať na digitálneho nomáda. Chcem však zostať verný aj spirituálnej stránke a použiť technológie ako pomoc, a nie prekážku v duševnom rozvoji seba a iných.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              
              {/* Right column - Image and contact */}
              <div className="creator-sidebar-column">
                <div className="creator-image-container">
                  <div className="creator-image"></div>
                </div>
                
                <div className="creator-question-card">
                  <p className="creator-question">
                    Máte záujem o web, ktorý bude rásť s Vami?
                  </p>

                  <div className="creator-contact-card">
                    <div className="contact-item">
                      <span className="contact-icon">
                        <i className="fas fa-user"></i>
                      </span>
                      <div className="contact-text">
                        <strong>Kontakt:</strong> MSc. Roman Szabo<br/> 
                        <span className="creator-position">freelance web developer | cloud analyst</span>
                      </div>
                    </div>
                    
                    <div className="contact-item">
                      <span className="contact-icon">
                        <i className="fas fa-envelope"></i>
                      </span>
                      <div className="contact-text">
                        <strong>Email:</strong> <a href="mailto:szabo.roman2@yahoo.com">szabo.roman2@yahoo.com</a>
                      </div>
                    </div>
                    
                    <div className="contact-item">
                      <span className="contact-icon">
                        <i className="fas fa-phone-alt"></i>
                      </span>
                      <div className="contact-text">
                        <strong>Tel:</strong> <a href="tel:+421948874164">+421 948 874 164</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatorPopup; 